import * as types from "./mutations-type";
export default {
    [types.SET_MSG](state, payload) {
        state.msg = payload
    },
    [types.SET_EDITAR](state, payload) {
        state.editar = payload
    },
    [types.SET_LISTA](state, payload) {
        state.lista = payload
    },
    [types.SET_PESQUISA](state, payload) {
        state.pesquisa = payload
    },
    [types.SET_MATRICULA](state, payload) {
        state.matricula = payload
    },
}